/* eslint-disable */
'use strict';
exports.__esModule = true;
exports.default = {
    "account": "บัญชี",
    "active_date": "วันที่ใช้งาน",
    "address": "ที่อยู่",
    "address2": "ที่อยู่ 2 (ไม่บังคับ)",
    "amount": "จำนวนเงิน",
    "and": "และ",
    "article": "รายการ",
    "buy": "การจัดซื้อ",
    "buyer": "ผู้ซื้อ",
    "buyer_info": "ข้อมูลผู้ซื้อ",
    "cancel": "ยกเลิก",
    "canceled": "ยกเลิกแล้ว",
    "cellphone": "โทรศัพท์มือถือ",
    "certification_expires": "ไม่ได้รับอนุญาตหรือหมดอายุ กรุณาเข้าสู่ระบบใหม่",
    "change_password": "เปลี่ยนรหัสผ่าน",
    "city": "เมือง",
    "clear": "ล้าง",
    "commercial": "เชิงพาณิชย์",
    "company": "บริษัท",
    "completed": "เสร็จแล้ว",
    "confirm_password": "ยืนยันรหัสผ่าน",
    "contact": "ติดต่อ",
    "country": "ประเทศ",
    "create": "สร้าง",
    "create_account": "สร้างบัญชี",
    "create_date": "วันที่สร้าง",
    "creationdate": "วันที่สร้าง",
    "currency": "สกุลเงิน",
    "customer_success": "สมัครสำเร็จ กรุณาตรวจสอบอีเมลเพื่อยืนยัน",
    "dead_line": "กำหนดเวลา",
    "dealer": "ตัวแทนจำหน่าย",
    "dealer_success": "รออนุมัติ",
    "description": "รายละเอียด",
    "domain": "โดเมน",
    "domain_in_use": "โดเมนถูกใช้งานแล้ว",
    "email": "อีเมล",
    "email_format_error": "รูปแบบอีเมลไม่ถูกต้อง",
    "email_used": "อีเมลนี้ถูกใช้งานแล้ว",
    "enter_character": "กรุณากรอกตัวอักษรในภาพ",
    "enter_confirm_password": "กรอกรหัสผ่านใหม่อีกครั้ง",
    "enter_new_password": "กรอกรหัสผ่านใหม่",
    "enter_old_password": "กรอกรหัสผ่านเดิม",
    "erp_list": "การสมัครสมาชิก",
    "erp_status": "สถานะ",
    "expire_date": "วันหมดอายุ",
    "female": "หญิง",
    "first_name": "ชื่อ",
    "forget_password": "ลืมรหัสผ่าน",
    "forgot_password": "ลืมรหัสผ่าน?",
    "form_not_exist": "ไม่พบแบบฟอร์ม",
    "format_error": "รูปแบบไม่ถูกต้อง",
    "group_code": "รหัสกลุ่ม",
    "group_name": "ชื่อกลุ่ม",
    "home_company_address": "ที่อยู่บ้าน/บริษัท",
    "image": "รูปภาพ",
    "information_success": "แก้ไขข้อมูลบัญชีสำเร็จ",
    "initial_info": "ข้อมูลเริ่มต้น",
    "input_password": "กรุณากรอกรหัสผ่าน",
    "input_password_again": "กรุณากรอกรหัสผ่านอีกครั้ง",
    "last_name": "นามสกุล",
    "legal_person": "ผู้มีอำนาจตามกฎหมาย",
    "male": "ชาย",
    "modify": "แก้ไข",
    "modify_erp_information": "แก้ไขข้อมูล ERP",
    "modules": "โมดูล",
    "month": "ผู้ใช้/เดือน",
    "name": "ชื่อ",
    "new_password": "รหัสผ่านใหม่",
    "new_password_toEmail": "เราได้ส่งรหัสผ่านใหม่ไปยังอีเมลของคุณแล้ว",
    "next": "ถัดไป",
    "noFoundurl": "ไม่พบอินสแตนซ์",
    "not_null": "มีช่องที่จำเป็นยังไม่ได้กรอก",
    "official_website": "เว็บไซต์ทางการ:",
    "ok": "ตกลง",
    "old_password": "รหัสผ่านเดิม",
    "old_password_error": "รหัสผ่านเดิมไม่ถูกต้อง",
    "one_time_payment": "ชำระครั้งเดียว",
    "operation": "การดำเนินการ",
    "or": "หรือ",
    "order": "คำสั่ง",
    "order-no": "เลขที่คำสั่งซื้อ",
    "order_close": "คำสั่งซื้อถูกปิดแล้ว",
    "order_list": "รายการคำสั่งซื้อ",
    "order_no": "เลขที่คำสั่งซื้อ",
    "order_status": "สถานะคำสั่งซื้อ",
    "other": "อื่นๆ",
    "paid": "ชำระแล้ว",
    "password": "รหัสผ่าน",
    "password_error": "รหัสผ่านต้องมี 6-20 ตัวอักษรและตัวเลข",
    "password_error_two": "รหัสผ่านไม่ตรงกัน",
    "password_least": "รหัสผ่านอย่างน้อย 6 ตัว และมีตัวเลขและตัวอักษร/อักขระพิเศษ",
    "password_strength": "ความแข็งแรงของรหัสผ่าน",
    "pay": "การจัดซื้อ",
    "pay_error": "ไม่สามารถดึงข้อมูลการชำระเงิน",
    "payment": "วิธีชำระเงิน",
    "payment_date": "วันที่ชำระเงิน",
    "personal": "ส่วนบุคคล",
    "please_email": "กรุณาตรวจสอบอีเมล",
    "pos": "ตำแหน่ง",
    "previous": "ก่อนหน้า",
    "price": "ราคา",
    "privacy": "การสร้างบัญชี SOMATIME ถือว่าคุณยอมรับ",
    "privacy_notice": "นโยบายความเป็นส่วนตัว",
    "product": "สินค้า",
    "product_list": "รายการสินค้า",
    "product_name": "ชื่อสินค้า",
    "purchase": "การจัดซื้อ",
    "purchase_success": "ซื้อสำเร็จ",
    "refunded": "คืนเงินแล้ว",
    "registered": "อีเมลนี้ถูกลงทะเบียนแล้ว",
    "registered_email_address": "เราได้ลงทะเบียนด้วยอีเมลของคุณแล้ว",
    "renewal": "ต่ออายุ",
    "repeat_password": "ยืนยันรหัสผ่าน",
    "requied": "จำเป็น",
    "requied_num": "ตัวเลขเท่านั้น",
    "require_tips": "ข้อมูลผู้ซื้อไม่ครบ",
    "required": "จำเป็น",
    "reseller": "ตัวแทนจำหน่าย",
    "resend": "ส่งใหม่",
    "reset_password": "เราได้ส่งอีเมลลิงก์ยืนยันรหัสผ่านไปยัง",
    "revoke": "ยกเลิกคำสั่งซื้อ",
    "revoke_tip1": "คุณต้องการปิดคำสั่งซื้อนี้หรือไม่",
    "role": "บทบาท",
    "search": "ค้นหา",
    "send_update": "ส่งข้อมูลอัปเดตจาก SOMATIME",
    "sex": "เพศ",
    "signIn": "เข้าสู่ระบบ",
    "sign_out": "ออกจากระบบ",
    "state": "รัฐ/จังหวัด",
    "status": "สถานะการชำระเงิน",
    "status_not_match": "สถานะไม่ตรงกัน",
    "strength_high": "สูง",
    "strength_low": "ต่ำ",
    "strength_mid": "กลาง",
    "submit": "ส่ง",
    "submitted": "ส่งแล้ว",
    "subscribe": "สมัคร",
    "subscribe-mon": "สมัคร-รายเดือน",
    "subscript_success": "สมัครสำเร็จ",
    "telephone": "โทรศัพท์",
    "tenant_list": "รายการเทนแนนต์",
    "tenant_management_system": "ระบบจัดการเทนแนนต์",
    "tenant_system": "ระบบเทนแนนต์",
    "terms_of_use": "ข้อกำหนดการใช้งาน",
    "time_info": "ข้อมูลเวลา",
    "title": "ชื่อเรื่อง",
    "unpaid": "ยังไม่ชำระ",
    "update_password_success": "เปลี่ยนรหัสผ่านสำเร็จ",
    "user": "ผู้ใช้",
    "user_check": "กรุณาอ่านและยอมรับนโยบายความเป็นส่วนตัวและข้อกำหนดการใช้งาน",
    "user_id": "รหัสผู้ใช้",
    "user_month": "เดือน",
    "user_not_active": "ผู้ใช้ยังไม่เปิดใช้งาน",
    "user_not_exist": "ไม่พบผู้ใช้",
    "user_password_error": "รหัสผ่านไม่ถูกต้อง",
    "user_qty": "จำนวนผู้ใช้",
    "username": "ชื่อผู้ใช้",
    "ver_code_error": "รหัสยืนยันไม่ถูกต้อง",
    "ver_code_exd": "รหัสยืนยันหมดอายุ",
    "visit": "เยี่ยมชม",
    "welcome_to_iceq": "ยินดีต้อนรับสู่ SOMATIME",
    "zip": "รหัสไปรษณีย์",
    "trial": "ทดลองใช้งาน",
    "requesting_a_trial": "สมัครสำเร็จ คุณจะได้รับข้อมูลเดโมภายใน 24 ชั่วโมง",
    "trial_orders_have_been_requested": "ได้ขอทดลองใช้งานแล้ว",
    "apply_trial": "ขอเดโม",
    "request_": "คำขอ",
    "trial_": "ทดลองใช้งาน",
    "on_trial": "อยู่ระหว่างทดลอง",
    "order_not_exist": "ไม่พบคำสั่งซื้อ",
    "wait_for_payment": "รอการชำระเงิน",
    "trial_reject": "ปฏิเสธเดโม",
    "tips": "คำแนะนำ",
    "confirm": "ยืนยัน",
    "cancel": "ยกเลิก",
    "trial_only_allow_one_time_payment_method": "เลือกชำระครั้งเดียวสำหรับทดลองเท่านั้น",
    "domain_info": "ข้อมูลโดเมน",
    "please_fill_in_domain_info": "กรุณากรอกข้อมูลโดเมน",
    "user_quantity_and_month_required": "ต้องระบุจำนวนผู้ใช้และเดือน",
    "password_must_be_the_same": "รหัสยืนยันต้องตรงกับรหัสใหม่",
    "enter_the_password_and_new_password": "กรุณากรอกรหัสผ่านและรหัสใหม่",
    "wrong_user_name_and_password": "ชื่อผู้ใช้หรือรหัสผ่านผิด",
    "close_the_page_without_saving": "ปิดหน้าโดยไม่บันทึก?",
    "cancel_input": "ยกเลิกการกรอก",
    "user_does_not_exist": "ไม่พบผู้ใช้",
    "modify_success": "แก้ไขสำเร็จ",
    "email_has_been_used": "อีเมลถูกใช้แล้ว",
    "created_successfully": "สร้างสำเร็จ",
    "error_tip_10098": "ส่งอีเมลล้มเหลว ติดต่อผู้ดูแล",
};